import React from 'react';

type CardTone = 'surface' | 'ink';

type CardOwnProps<C extends React.ElementType> = {
  as?: C;
  tone?: CardTone;
  pad?: number;
  className?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
};

type CardProps<C extends React.ElementType> = CardOwnProps<C> &
  Omit<React.ComponentPropsWithoutRef<C>, keyof CardOwnProps<C>>;

const TONE_CLASS: Record<CardTone, string> = {
  surface: 'bg-we-surface text-we-ink border border-we-ink/15',
  ink: 'bg-we-ink text-we-bg border border-we-ink',
};

const LAYOUT = 'rounded-xl';

function Card<C extends React.ElementType = 'section'>({
  as,
  tone = 'surface',
  pad = 24,
  className = '',
  style,
  children,
  ...rest
}: CardProps<C>) {
  const Component = as ?? 'section';
  return (
    <Component
      className={`${TONE_CLASS[tone]} ${LAYOUT} ${className}`.trim()}
      style={{ padding: pad, ...style }}
      {...rest}
    >
      {children}
    </Component>
  );
}

export default Card;
